// extracted by mini-css-extract-plugin
export default {"certificate":"styles_certificate__Kotlq"};